import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';

class RolesCheckboxListStore {

    @setter @observable addEditSelectableRolesList = [];

    @setter @observable selectableAddRolesList = [];

    @setter @observable selectableRemoveRolesList = [];

    @observable editTypes = {
        ADD : 'add',
        REMOVE : 'remove'
    }

    @action async buildAddEditCheckboxRolesList(roleList, checkedRolesIdsList) {

        let newList = [];
        roleList.forEach((role) => {
            const selectableItem = {
                id: role.id,
                selected: checkedRolesIdsList.some(id => id === role.id),
                visible: true,
                itemData: role,
                disabled: false
            };      
            newList.push(selectableItem);   
        });
        
        this.addEditSelectableRolesList = newList.sort((a, b) => (a.itemData.name > b.itemData.name) ? 1 : -1);       
    }
    
    @action async buildUncheckedCheckboxRolesList(roleList, editMode) {   

        let newList = [];
        roleList.forEach((role) => {      

            const selectableItem = {
                id: role.id,
                selected: false,
                visible: true,
                itemData: role,
                disabled: false
            };            
            newList.push(selectableItem);
        });
        
        newList.sort((a, b) => (a.itemData.name > b.itemData.name) ? 1 : -1);

        if(editMode === this.editTypes.ADD) {
            this.selectableAddRolesList = newList;
        }
        else if(editMode === this.editTypes.REMOVE) {
            this.selectableRemoveRolesList = newList;
        }
    }
}

export default new RolesCheckboxListStore();


// WEBPACK FOOTER //
// ./src/stores/rolesCheckboxListStore.js